const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer

export class ProductCardForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  connectedCallback () {
    super.connectedCallback()

    this.form.dataset.nostoType = 'recommendations'
    const placementId = this.closest('.nosto_element')?.id

    if (placementId) {
      this.form.dataset.nostoPlacementId = placementId
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.listeners.add(
      this.els.variant.element,
      'change',
      this.onVariantChange.bind(this),
    )
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (event) {
    event.preventDefault()
    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  async onVariantChange () {
    const option = this.els.variant.element.selectedOptions[0]
    let string = ''

    if (option.dataset.available === 'true') {
      this.els.submit.element.removeAttribute('disabled')
      string = window.theme.strings.addToCart
    } else {
      this.els.submit.element.setAttribute('disabled', '')
      string = window.theme.strings.soldOut
    }

    this.els.submit.element.setAttribute('aria-label', string)
    this.els.submitText.element.dataset.text = string

    if (option.dataset.price === this.currentPrice) return

    this.dataset.currentPrice = option.dataset.price

    try {
      const productUrl = `${this.productUrl}?variant=${option.value}`
      const response = await fetchSingleSection('product-price', productUrl)

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const bodyContent = newDOM.querySelector('.prd-Price')

      this.els.price.element.innerHTML = bodyContent.outerHTML
    } catch (error) {
      console.error('Failed to update product upsell price', error)
    }
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  get currentPrice () {
    return this.dataset.currentPrice
  }

  get productUrl () {
    return this.dataset.productUrl
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm)
}
